import { render, staticRenderFns } from "./cust-auth-layout.vue?vue&type=template&id=655895f1&scoped=true"
import script from "./cust-auth-layout.vue?vue&type=script&lang=js"
export * from "./cust-auth-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655895f1",
  null
  
)

export default component.exports